"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Filters;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _productListingContext = require("../product-listing-context");
var _categoryItem = _interopRequireDefault(require("./category-item"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _link = _interopRequireDefault(require("../../../buttons/link"));
var _businessItem = _interopRequireDefault(require("./business-item"));
var _tagItem = _interopRequireDefault(require("./tag-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MobileToolbar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileToolbar",
  class: "pl-m1ni5orh"
});
const Gradient = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Gradient",
  class: "pl-gi8ms7o"
});
const FilterContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FilterContainer",
  class: "pl-f1lqkrpk",
  vars: {
    "f1lqkrpk-0": [({
      showFilters
    }) => showFilters ? 'flex' : 'none']
  }
});
const FilterHeader = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FilterHeader",
  class: "pl-f1dtzo6i",
  vars: {
    "f1dtzo6i-0": [({
      showFilters
    }) => showFilters ? 'flex' : 'none']
  }
});
const FilterSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FilterSection",
  class: "pl-fosns32"
});
const SectionHeader = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SectionHeader",
  class: "pl-s1kq6t49"
});
const CategorySelector = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategorySelector",
  class: "pl-c13zt66n"
});
const TagSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TagSection",
  class: "pl-to1c79a"
});
function Filters({
  categoryFilterLabel = 'Categories',
  businessFilterLabel = 'Business Types',
  tagFilterLabel = 'Filters/Features',
  mobileFilterOpenCtaText = 'Filters',
  mobileFilterApplyCtaText = 'Apply',
  mobileFilterHeading = 'Filter',
  categoryTotalTileText = '{QTY} items in {CATEGORY}'
}) {
  const {
    businesses,
    tags,
    setTags,
    categories,
    activeCategory,
    setActiveCategory,
    setUserInteracted,
    selectorCustomProperties
  } = (0, _react.useContext)(_productListingContext.ProductListingContext);
  const [showFilters, setShowFilters] = (0, _react.useState)(false);
  const [prevCategory, setPrevCategory] = (0, _react.useState)(activeCategory);
  const [prevTags, setPrevTags] = (0, _react.useState)(tags);
  (0, _react.useEffect)(() => {
    if (showFilters) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showFilters]);
  const handleMobileFilters = () => {
    setPrevCategory(activeCategory);
    setPrevTags(tags);
    setShowFilters(!showFilters);
  };
  const revertFilters = () => {
    setActiveCategory(prevCategory);
    setTags(prevTags);
    setShowFilters(!showFilters);
  };
  const toggleTag = label => {
    setUserInteracted(true);
    const newTags = tags?.map(tag => {
      if (tag.tagName?.Text === label) {
        return {
          ...tag,
          isActive: !tag.isActive
        };
      }
      return tag;
    });
    setTags(newTags);
  };
  const handleCategoryChange = category => {
    const url = new URL(window.location.href);
    setUserInteracted(true);
    setActiveCategory(category);
    url.searchParams.set('category', category.name?.Text);
    window.history.pushState({}, '', url);
  };
  const filterIcon = /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "filter"
  });
  const filterIconAttributes = filterIcon ? {
    icon: filterIcon
  } : {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MobileToolbar, {
    "data-cy": "mobile-toolbar"
  }, /*#__PURE__*/_react.default.createElement("span", null, categoryTotalTileText.replace('{QTY}', activeCategory.productTiles?.length ?? 0).replace('{CATEGORY}', activeCategory.name?.Text)), /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
    "data-partial": "bluectas",
    "data-cy": "filter-button",
    design: "primary",
    type: "button",
    text: mobileFilterOpenCtaText,
    onClick: handleMobileFilters,
    className: "filter-button",
    trackingCustomProperties: selectorCustomProperties
  }, filterIconAttributes))), /*#__PURE__*/_react.default.createElement(FilterContainer, {
    showFilters: showFilters,
    "data-cy": "filter-container",
    "data-partial": "pricing-nav"
  }, /*#__PURE__*/_react.default.createElement(FilterHeader, {
    "data-cy": "mobile-filter-header",
    showFilters: showFilters
  }, /*#__PURE__*/_react.default.createElement("span", null, mobileFilterHeading), /*#__PURE__*/_react.default.createElement(_link.default, {
    id: "close-button",
    dataCy: "close-button",
    type: "button",
    design: "inline",
    icon: "x",
    onClick: revertFilters,
    isPromo: false
  })), /*#__PURE__*/_react.default.createElement(FilterSection, null, /*#__PURE__*/_react.default.createElement(CategorySelector, {
    "data-cy": "category-selector"
  }, /*#__PURE__*/_react.default.createElement(SectionHeader, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    className: "captitle",
    text: categoryFilterLabel
  })), categories?.map((category, i) => /*#__PURE__*/_react.default.createElement(_categoryItem.default, (0, _extends2.default)({
    isActive: activeCategory._name === category._name,
    onClick: () => handleCategoryChange(category),
    key: i,
    trackingCustomProperties: selectorCustomProperties
  }, category)))), tags?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "tag-selector"
  }, /*#__PURE__*/_react.default.createElement(SectionHeader, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    className: "captitle",
    text: tagFilterLabel
  })), /*#__PURE__*/_react.default.createElement(TagSection, null, tags.map(({
    id,
    tagName: {
      Text: label
    },
    isActive
  }, i) => /*#__PURE__*/_react.default.createElement(_tagItem.default, {
    id: id,
    key: i,
    variant: "filter",
    label: label,
    isActive: isActive,
    onClick: () => toggleTag(label),
    trackingCustomProperties: selectorCustomProperties
  })))), businesses?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "business-selector"
  }, /*#__PURE__*/_react.default.createElement(SectionHeader, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    className: "captitle",
    text: businessFilterLabel
  })), businesses.map(({
    id,
    businessName: {
      Text: label
    },
    isActive
  }, i) => /*#__PURE__*/_react.default.createElement(_businessItem.default, {
    id: id,
    key: i,
    label: label,
    isActive: isActive,
    trackingCustomProperties: selectorCustomProperties
  })))), /*#__PURE__*/_react.default.createElement(Gradient, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    design: "merch",
    size: "small",
    "data-cy": "apply-button",
    text: mobileFilterApplyCtaText,
    isPromo: false,
    onClick: () => setShowFilters(!showFilters),
    trackingCustomProperties: selectorCustomProperties
  }))));
}
Filters.propTypes = {
  businessFilterLabel: _propTypes.default.string,
  categoryFilterLabel: _propTypes.default.string,
  tagFilterLabel: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object,
  mobileFilterOpenCtaText: _propTypes.default.string,
  mobileFilterApplyCtaText: _propTypes.default.string,
  mobileFilterHeading: _propTypes.default.string,
  categoryTotalTileText: _propTypes.default.string
};